module.exports = __webpack_public_path__ + "files/6f2241d8d5da5efb387e2498ef5a2401.png";